<template>
  <section class="section">
    <h1
      class="
        has-text-centered has-text-weight-bold
        subtitle
        is-size-4-mobile is-size-3-desktop
        pdx-small-desktop pdx-small-touch
        has-text-left-touch
      "
    >
      Which Soaps are the Most Stressful to Watch?
    </h1>
    <h2
      class="
        has-text-centered
        subtitle
        is-size-6-mobile is-size-4-desktop
        pdx-large-desktop pdx-small-touch
        has-text-left-touch
      "
    >
      Of Britain’s four longest-running TV soaps, it is
      <strong>EastEnders</strong> that causes the most stress to its viewers,
      with <strong>36,818 stressful tweets</strong> frantically typed out over
      the past 12 months.<br /><br />
      That's not to say any of the other three soaps are much more relaxing
      affairs, as <strong>Coronation Street</strong> and
      <strong>Emmerdale</strong> recorded <strong>29,918</strong> and
      <strong>20,427</strong> stressful tweets. <strong>Hollyoaks</strong> was
      found to be the least stressful Soap to watch, with just
      <strong>14,932 stressed tweets</strong> recorded over the past 12 months
    </h2>

    <chart-tab showType="British Soap"></chart-tab>
  </section>
</template>

<script>
import ChartTab from "@/components/ChartTab";
export default {
  components: {
    ChartTab,
  },
};
</script>

<style lang="scss" scoped></style>
